<template>
  <section :class="$style.container">
    <figure :class="$style.image">
      <img
        :alt="title"
        :src="src"
      >
    </figure>
    <HeadingMedium>
      {{ title }}
    </HeadingMedium>
  </section>
</template>

<script>
import { HeadingMedium } from '@jumpcloud/ui-components';

export default {
  name: 'NoItems',

  components: {
    HeadingMedium,
  },

  props: {
    src: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'No items found',
    },
  },
};
</script>

<style module scoped>
.container {
  padding: var(--jc-size-3) var(--jc-spacer-medium);
  text-align: center;
}

.image {
  margin: 0 auto var(--jc-spacer-medium);
  max-width: 25ch;
}

.image /deep/ img,
.image /deep/ svg {
  height: var(--jc-size-14);
  width: 100%;
}
</style>
